import React, { ReactNode } from 'react';
import { ArchitecturalForm } from './ArchitecturalForm';
interface CtaBandProps {
  title: string;
  text: string;
  children: ReactNode;
  tone?: 'aubergine' | 'plum';
  visual?: ReactNode;
}
export function CtaBand({
  title,
  text,
  children,
  tone = 'plum',
  visual
}: CtaBandProps) {
  return <section className={`on-dark overflow-hidden ${tone === 'plum' ? 'bg-plum' : 'bg-aubergine'} text-porcelain`} data-id="element-469" data-mp="100tz8uv3w58u">
      <div className="mx-auto grid max-w-7xl items-center gap-10 px-6 py-20 lg:grid-cols-12 lg:px-10 lg:py-24" data-id="element-470" data-mp="v3k3yyl1czd3">
        <div className={visual ? 'lg:col-span-6' : 'lg:col-span-8'} data-id="element-471" data-mp="qzvqy0dmxbkg">
          <h2 className="text-3xl font-semibold leading-[1.1] tracking-tight sm:text-4xl lg:text-5xl" data-id="element-472" data-mp="m35bnf9nmk03">{title}</h2>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-porcelain/75" data-id="element-473" data-mp="h4at8eflmxgi">{text}</p>
          <div className="mt-10 flex flex-wrap gap-4" data-id="element-474" data-mp="2gesik05tmawu">{children}</div>
        </div>
        {visual ? <div className="h-[320px] sm:h-[420px] lg:col-span-6 lg:h-[520px]" data-id="element-475" data-mp="2bibrax3brgfj">{visual}</div> : <div className="hidden lg:col-span-4 lg:block" data-id="element-476" data-mp="2p4iir3f5vzfw">
            <ArchitecturalForm variant="frame" tone="dark" className="mx-auto max-w-xs" data-id="element-477" data-mp="2t86r3obmaz27" />
          </div>}
      </div>
    </section>;
}